import { defineRoutes } from "@/service/routing/schema";

const base = "/wideo";

export const videoRoutes = defineRoutes({
  "remedium.video.show": ({ slug, id }) => `${base}/${slug}-${id}`,
  "remedium.video.playlist.show": ({ slug, id, videoSlug, videoId }) => {
    if (!videoSlug && !videoId) {
      return `${base}/${slug}-${id}`;
    }
    return `${base}/${slug}-${id}/${videoSlug}-${videoId}`;
  },
} as const);
